document.addEventListener(
  "DOMContentLoaded",
  () => {

    const header =
      document.querySelector(
        ".header-luxury-v2"
      );

    if (!header) return;

    const searchToggle =
      header.querySelector(
        ".header-luxury-v2__search-toggle"
      );

    const search =
      header.querySelector(
        ".header-luxury-v2__search"
      );

    const searchInput =
      search?.querySelector(
        "input"
      );

    /* =====================================
       STICKY HEADER
    ===================================== */

  function handleScroll() {

  const isProductPage =
    window.location.pathname.includes('/products/');

  const isCartPage =
    window.location.pathname === '/cart';

  const isAccountPage =
    window.location.pathname.includes('/account');

  if (
    window.scrollY > 40 ||
    isProductPage ||
    isCartPage ||
    isAccountPage
  ) {

    header.classList.add(
      'header-luxury-v2--scrolled'
    );

  } else {

    header.classList.remove(
      'header-luxury-v2--scrolled'
    );

  }

}

    handleScroll();

    window.addEventListener(
      "scroll",
      handleScroll,
      {
        passive: true
      }
    );

    /* =====================================
       SEARCH TOGGLE
    ===================================== */

    if (
      searchToggle &&
      search
    ) {

      searchToggle.addEventListener(
        "click",
        (event) => {

          event.stopPropagation();

          search.classList.toggle(
            "header-luxury-v2__search--active"
          );

          if (
            search.classList.contains(
              "header-luxury-v2__search--active"
            )
          ) {

            setTimeout(
              () => {

                searchInput?.focus();

              },
              200
            );

          }

        }
      );

      /* =====================================
         CLICK OUTSIDE
      ===================================== */

      document.addEventListener(
        "click",
        (event) => {

          const clickedInsideSearch =
            search.contains(
              event.target
            );

          const clickedToggle =
            searchToggle.contains(
              event.target
            );

          if (
            !clickedInsideSearch &&
            !clickedToggle
          ) {

            search.classList.remove(
              "header-luxury-v2__search--active"
            );

          }

        }
      );

      /* =====================================
         ESC CLOSE
      ===================================== */

      document.addEventListener(
        "keydown",
        (event) => {

          if (
            event.key === "Escape"
          ) {

            search.classList.remove(
              "header-luxury-v2__search--active"
            );

          }

        }
      );

    }

    /* =====================================
       MEGA MENU DELAY
    ===================================== */

    const menuItems =
      document.querySelectorAll(
        ".header-luxury-v2__item"
      );

    menuItems.forEach(
      (item) => {

        let timeout;

        item.addEventListener(
          "mouseenter",
          () => {

            clearTimeout(
              timeout
            );

            item.classList.add(
              "is-open"
            );

          }
        );

        item.addEventListener(
          "mouseleave",
          () => {

            timeout =
              setTimeout(
                () => {

                  item.classList.remove(
                    "is-open"
                  );

                },
                120
              );

          }
        );

      }
    );

    /* =====================================
   MOBILE DRAWER
===================================== */

const mobileToggle =
  document.querySelector(
    ".header-luxury-v2__mobile-toggle"
  );

const mobileDrawer =
  document.querySelector(
    ".header-luxury-v2__mobile-drawer"
  );

const mobileOverlay =
  document.querySelector(
    ".header-luxury-v2__mobile-overlay"
  );

const mobileClose =
  document.querySelector(
    ".header-luxury-v2__mobile-close"
  );

function openMobileDrawer() {

  if (!mobileDrawer) return;

  mobileDrawer.classList.add(
    "is-open"
  );

  mobileOverlay?.classList.add(
    "is-open"
  );

  document.body.style.overflow =
    "hidden";

}

function closeMobileDrawer() {

  if (!mobileDrawer) return;

  mobileDrawer.classList.remove(
    "is-open"
  );

  mobileOverlay?.classList.remove(
    "is-open"
  );

  document.body.style.overflow =
    "";

}

/* OPEN */

mobileToggle?.addEventListener(
  "click",
  () => {

    openMobileDrawer();

  }
);

/* CLOSE BUTTON */

mobileClose?.addEventListener(
  "click",
  () => {

    closeMobileDrawer();

  }
);

/* OVERLAY */

mobileOverlay?.addEventListener(
  "click",
  () => {

    closeMobileDrawer();

  }
);

/* ESC */

document.addEventListener(
  "keydown",
  (event) => {

    if (
      event.key === "Escape"
    ) {

      closeMobileDrawer();

    }

  }
);

/* =====================================
   MOBILE ACCORDION
===================================== */

const mobileGroups =
  document.querySelectorAll(
    ".header-luxury-v2__mobile-group"
  );

mobileGroups.forEach(
  (group) => {

    const trigger =
      group.querySelector(
        ".header-luxury-v2__mobile-group-trigger"
      );

    trigger?.addEventListener(
      "click",
      () => {

        const isOpen =
          group.classList.contains(
            "is-open"
          );

        /* CLOSE OTHERS */

        mobileGroups.forEach(
          (item) => {

            item.classList.remove(
              "is-open"
            );

          }
        );

        /* REOPEN CURRENT */

        if (!isOpen) {

          group.classList.add(
            "is-open"
          );

        }

      }
    );

  }
);

/* =====================================
   WINDOW RESIZE SAFETY
===================================== */

window.addEventListener(
  "resize",
  () => {

    if (
      window.innerWidth > 989
    ) {

      closeMobileDrawer();

    }

  }
);

  }
);

const megaItems = document.querySelectorAll(
  ".header-luxury-v2__mega-item"
);

megaItems.forEach(item => {

  item.addEventListener("mouseenter", () => {

    const mega = item.closest(".header-luxury-v2__mega");

    if (!mega) return;

    mega.querySelectorAll(".header-luxury-v2__submenu")
      .forEach(panel => panel.classList.remove("active"));

    const id = item.dataset.menu;

    const panel = mega.querySelector(
      '.header-luxury-v2__submenu[data-menu="' + id + '"]'
    );

    if (panel) {
      panel.classList.add("active");
    }

  });
  

});

document.querySelectorAll(".header-luxury-v2__mega").forEach(mega => {

  mega.addEventListener("mouseleave", () => {

    mega.querySelectorAll(".header-luxury-v2__submenu")
      .forEach(panel => {

        panel.classList.remove("active");

      });

  });

});

const mobileSubgroups =
  document.querySelectorAll(
    ".header-luxury-v2__mobile-subgroup"
  );

mobileSubgroups.forEach((group) => {

  const trigger =
    group.querySelector(
      ".header-luxury-v2__mobile-subtrigger"
    );

  trigger?.addEventListener("click", () => {

    const isOpen =
      group.classList.contains("is-open");

    mobileSubgroups.forEach((item) => {
      item.classList.remove("is-open");
    });

    if (!isOpen) {
      group.classList.add("is-open");
    }

  });

});